module.exports = __webpack_public_path__ + "static/team-8-1d117d594846a2d6bac43ff8ff27f9c3.jpeg";